import { render } from "./jiguangpush.vue?vue&type=template&id=16639e5e&scoped=true"
import script from "./jiguangpush.vue?vue&type=script&lang=js"
export * from "./jiguangpush.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16639e5e"]])

export default __exports__